import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { ExclamationTriangleIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const NoAccess: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-24 w-24 text-red-500 mb-6">
            <ExclamationTriangleIcon className="h-full w-full" />
          </div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            Nincs hozzáférés
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            A fiókod nincs még szervezethez rendelve
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg p-6">
          <div className="flex items-center space-x-3 mb-4">
            <UserGroupIcon className="h-8 w-8 text-blue-500" />
            <h3 className="text-lg font-medium text-gray-900">Mit tehetsz?</h3>
          </div>

          <div className="space-y-4 text-sm text-gray-600">
            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-2"></span>
              <p>
                <strong>Vedd fel a kapcsolatot a rendszergazdával</strong> - 
                kérd meg, hogy adjon hozzá egy szervezethez
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-2"></span>
              <p>
                <strong>Ellenőrizd az email címed</strong> - 
                lehet, hogy kaptál meghívót egy szervezetbe
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <span className="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mt-2"></span>
              <p>
                <strong>Várd meg a jóváhagyást</strong> - 
                ha nemrég regisztráltál, a hozzáférés jóváhagyás alatt lehet
              </p>
            </div>
          </div>

          {user && (
            <div className="mt-6 p-4 bg-gray-50 rounded-lg">
              <h4 className="font-medium text-gray-900 mb-2">Fiók adatok:</h4>
              <div className="space-y-1 text-sm text-gray-600">
                <p><strong>Név:</strong> {user.displayName}</p>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Szerepkör:</strong> {user.role}</p>
                <p><strong>Szervezet ID:</strong> {user.organizationId || 'Nincs rendelve'}</p>
              </div>
            </div>
          )}
        </div>

        <div className="text-center">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Frissítés
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoAccess; 